import RichText from '@/components/RichText';
import { cls } from '@/utils/cls';
import styles from './FooterV2.module.scss';
import type { FooterV2Props } from './types';
import { transformLabel } from '@/utils/transformLabel';
import Image from 'next/image';
export default function FooterV2({
  copy,
  links,
  isLightMode = false,
  extendStyles,
  footerBackgroundColor,
  footerTextColor,
  bottomPaddingValue = '1.25rem'
}: FooterV2Props) {
  const transformedCopy = transformLabel(copy);
  const icons = ['/lock-icon.svg', '/hammer-icon.svg'];
  const customBackgroundStyle = {
    backgroundColor: footerBackgroundColor || 'var(--color-white)'
  };
  const customCopyStyle = footerTextColor ? {
    color: footerTextColor
  } : undefined;
  const conditionalTextStyle = !isLightMode ? customCopyStyle : undefined;
  const rootClassName = cls(styles.root, extendStyles);
  return <div className={rootClassName} style={{
    ...(!isLightMode ? customBackgroundStyle : undefined),
    paddingBottom: bottomPaddingValue
  }} data-sentry-component="FooterV2" data-sentry-source-file="FooterV2.tsx">
			<hr className={styles.topDivider} />
			<footer className={styles.footer}>
				<RichText text={transformedCopy} style={conditionalTextStyle} className={styles.copy} data-sentry-element="RichText" data-sentry-source-file="FooterV2.tsx" />
				<hr />
				<nav className={styles.links}>
					{links.map((link, i) => {
          const icon = icons[i] || null;
          return <a key={`footer-link-${i}`} href={link.linkDestination} rel="noopener noreferrer" target="_blank" className={styles.linkItem} style={conditionalTextStyle}>
								{icon && <Image src={icon} alt="" width={18} height={22} role="presentation" />}
								{link.linkText}
							</a>;
        })}
				</nav>
			</footer>
		</div>;
}